import { ColorCustomisation, ColorPreset } from '@treetop/shared/color-presets';

import { ImportMode } from './GuidelineHubInformationDto';
import { Ucum } from './ucum.model';

export enum ExportConnectionType {
  Ftp = 'Ftp',
  AzureBlob = 'AzureBlob',
}

export enum ExportFormat {
  Pdf = 'Pdf',
  Html = 'Html',
}

type ExportConnectionBase = {
  type: ExportConnectionType;
  name: string;
  password?: string;
  secretIdentifier?: string;
  remotePath?: string;
  /** Formats uploaded to this destination. Undefined or empty for connections configured before the format selection existed, which are treated as PDF only. */
  formats?: ExportFormat[];
};

export type ExportConnection =
  | (ExportConnectionBase & { type: ExportConnectionType.Ftp; host?: string; port?: number; username?: string })
  | (ExportConnectionBase & { type: ExportConnectionType.AzureBlob; containerName?: string });

export type ExportSettings = {
  externalExportEnabled: boolean;
  externalExportConnections: ExportConnection[];
  pdfExportDisclaimer?: string;
  allowUnpublishedPdfExport: boolean;
  htmlExportEnabled: boolean;
};

export type OfflineSettings = {
  allowOfflineSync: boolean;
  syncAllGuidelines: boolean;
  syncTaxonomyNodeIds: string[];
};

export type ReviewSettings = {
  minimumNumberOfReviewers: number;
  allowOwnerToBypassReviewers: boolean;
};

export type ImportSettings = {
  isImportEnabled: boolean;
  defaultImportMode?: ImportMode;
};

export type RevisionDateSettings = {
  isRevisionDateEnabled?: boolean;
  isRevisionDateRequired?: boolean;
  soonToExpirePeriod?: Ucum;
};

export type OrganisationSettings = {
  revisionDateSettings?: RevisionDateSettings;
  importSettings?: ImportSettings;
  isApprovalNoteEnabled?: boolean;
  isReaderFeedbackEnabled: boolean;
  isPersonalNotesEnabled: boolean;
  isTemporaryEditorRoleEnabled?: boolean;
  privacyNoticeUrl?: string;
  reviewSettings?: ReviewSettings;
  exportSettings: ExportSettings;
  offlineSettings: OfflineSettings;
  customisations?: Partial<{
    colorPresets: ColorPreset[];
    flowchart: ColorCustomisation;
  }>;
};
